/**
 * Entity types that support tags for aggregation
 */
export var TaggableEntityType;
(function (TaggableEntityType) {
    TaggableEntityType["CAMPAIGN"] = "campaign";
    TaggableEntityType["REDEMPTION"] = "redemption";
    TaggableEntityType["BUSINESS"] = "business";
    TaggableEntityType["TOKEN_METADATA"] = "token_metadata";
    TaggableEntityType["USER_STATUS_TYPE"] = "user_status_type";
})(TaggableEntityType || (TaggableEntityType = {}));
//# sourceMappingURL=taggable-entity-type.enum.js.map